<script setup>
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'
import { useAboutRaaiStore } from '@/store/aboutRaai'

const route = useRoute()

const aboutRaaiStore = useAboutRaaiStore()

const pageData = ref({})

onBeforeRouteUpdate(async (to) => {
    await aboutRaaiStore.getAboutRaaiPage(to.params.subLinkId)
    pageData.value = aboutRaaiStore.aboutRaaiPage
})

onMounted(async () => {
    await aboutRaaiStore.getAboutRaaiPage(route.params.subLinkId)
    pageData.value = aboutRaaiStore.aboutRaaiPage
})
</script>

<template>
    <h1 class="about_raai_page_title">{{ pageData.title }}</h1>
    <div
        class="about_raai_page_text"
        v-html="pageData.text"
    />
</template>

<style lang="scss">
.about_raai_page_title {
    font-size: 36px;
    font-weight: 600;
    line-height: 40px;
    color: #0635ac;
    text-align: left;
    text-transform: uppercase;

    @media screen and (max-width: 767px) {
        font-size: 28px;
        line-height: 36px;
        text-align: left;
    }
}

.about_raai_page_text {
    text-align: left;
    margin-top: 15px;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;

    h1,
    h2,
    h3,
    h4,
    h5 {
        margin-bottom: 16px;
    }

    p {
        margin-bottom: 16px;
    }

    ol {
        padding-left: 22.15px;
        margin-bottom: 16px;

        .ql-indent-1 {
            margin-left: 22.15px;
        }
    }

    ul {
        padding-left: 19.2px;
        margin-bottom: 16px;

        .ql-indent-1 {
            margin-left: 22.15px;
        }
    }

    .ql-align-right {
        text-align: right;
    }

    .ql-align-center {
        text-align: center;
    }

    .ql-align-left {
        text-align: left;
    }
}
</style>
